// ResizeImage.ts
export default async function resizeAndConvertToJPG(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    // eslint-disable-next-line consistent-return
    reader.onload = (e) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      if (!e.target?.result) return reject("Cannot read image file");

      img.src = e.target.result as string;

      // eslint-disable-next-line consistent-return
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        // eslint-disable-next-line prefer-promise-reject-errors
        if (!ctx) return reject("Failed to initialize canvas");

        const MAX_WIDTH = 800;
        const scale = MAX_WIDTH / img.width;
        const width = MAX_WIDTH;
        const height = img.height * scale;

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          // eslint-disable-next-line consistent-return
          (blob) => {
            // eslint-disable-next-line prefer-promise-reject-errors
            if (!blob) return reject("Unable to create blob");

            const newFile = new File([blob], file.name.replace(/\.\w+$/, ".jpg"), {
              type: "image/jpeg",
              lastModified: Date.now(),
            });

            resolve(newFile);
          },
          "image/jpeg",
          0.92, // Image quality (0.0 - 1.0)
        );
      };

      // eslint-disable-next-line prefer-promise-reject-errors
      img.onerror = () => reject("Error loading image");
    };

    reader.readAsDataURL(file);
  });
}
